import { ChangeDetectionStrategy, Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { AuthService } from '@features/authenticate/services/auth.service';
import { User } from '@features/authenticate/types/user';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';

@Component({
  selector: 'app-profile-info',
  standalone: true,
  imports: [ UserAvatarComponent ],
  templateUrl: './profile-info.component.html',
  styleUrl: './profile-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProfileInfoComponent implements OnInit {
  private _authService: AuthService = inject(AuthService);


  protected user: WritableSignal<User> = signal({} as User);


  ngOnInit (): void {
    this._authService.getRegisteredUser()
      .subscribe((registeredUser: Readonly<User> | undefined) => {
        if (registeredUser)
          this.user.set(registeredUser);
      });
  }
}
